
type Props = {
  fillColor?: string,
} & typeof defaultProps;

const defaultProps = {
  fillColor: '#7E7E7E',
};
const ForwardArrowIcon = function ForwardArrowIcon(props: Props) {
  const { fillColor } = props;
  return (
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg" className="forward-arrow-icon">
      <path d="M9.07738 0.271695C8.89758 0.0518434 8.61136 -0.0455192 8.33811 0.0202161C8.06487 0.0859514 7.85152 0.303495 7.78705 0.582113C7.72258 0.86073 7.81807 1.15257 8.03368 1.33591L13.3586 6.77193H0.746225C0.351668 6.79328 0.0424805 7.12571 0.0424805 7.52859C0.0424805 7.93147 0.351668 8.26391 0.746225 8.28525H13.3586L8.02533 13.7149C7.74648 14.0127 7.74648 14.4813 8.02533 14.7791C8.16358 14.9205 8.35135 15 8.54718 15C8.74301 15 8.93078 14.9205 9.06903 14.7791L15.6652 8.05325C15.8071 7.91402 15.8872 7.72191 15.8872 7.52114C15.8872 7.32038 15.8071 7.12826 15.6652 6.98903L9.07738 0.271695Z" fill={fillColor} />
    </svg>
  );
};
ForwardArrowIcon.defaultProps = defaultProps;
export default ForwardArrowIcon;